import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },

    title: {
      width: '60%',
      height: 28,
      marginTop: theme.spacing(0.5),
    },

    badge: {
      width: 38,
      height: 32,
      marginTop: theme.spacing(-1.5),
    },
  }),
  { name: 'Loader' }
);
